'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';

export function Banner({ isSmall = false, className }: { isSmall?: boolean; className?: string }) {
  const { t } = useTranslations();

  if (isSmall) {
    return (
      <div
        className={cn(
          'relative flex w-full flex-col items-start justify-between gap-6 overflow-hidden rounded-[24px] p-6',
          'ea-banner__container',
          className,
        )}
      >
        <p className="w-full max-w-[260px] text-balance text-2xl font-semibold leading-[1.2] tracking-tighter text-white sm:text-3xl sm:leading-[1.2] lg:text-[32px] lg:leading-[1.2]">
          Rezervujte si svoj termín ešte dnes!
        </p>
        <Button asChild variant={'white'}>
          <Link prefetch={false} href={'/rezervacia'}>
            {t('text4069')}
          </Link>
        </Button>
        <Image
          src={'/images/banner-model.png'}
          alt={t('text4069')}
          width={0}
          height={0}
          className="absolute right-0 top-0 z-10 h-full w-auto sm:right-4"
          sizes="100vw"
        />
      </div>
    );
  }

  return (
    <>
      <div
        className={cn(
          'relative flex w-full flex-col items-start justify-between gap-6 overflow-hidden rounded-[24px] p-6 md:hidden',
          'ea-banner__container',
          className,
        )}
      >
        <p className="w-full max-w-[260px] text-balance text-2xl font-semibold leading-[1.2] tracking-tighter text-white sm:text-3xl sm:leading-[1.2] lg:text-[32px] lg:leading-[1.2]">
          Rezervujte si svoj termín ešte dnes!
        </p>
        <Button asChild variant={'white'}>
          <Link prefetch={false} href={'/rezervacia'}>
            {t('text4069')}
          </Link>
        </Button>
        <Image
          src={'/images/banner-model.png'}
          alt={t('text4069')}
          width={0}
          height={0}
          className="absolute right-0 top-0 z-10 h-full w-auto sm:right-4"
        />
      </div>
      <div
        className={cn(
          'custom-container',
          'relative hidden w-full items-center justify-between rounded-[24px] p-8 md:flex md:p-12 lg:p-16',
          'ea-banner__container',
          className,
        )}
      >
        <p className="relative z-10 w-full text-balance text-4xl font-semibold leading-[1.2] tracking-tighter text-white md:max-w-[400px] md:leading-[1.2] lg:max-w-[500px] lg:text-5xl lg:leading-[1.2] xl:leading-[1.2]">
          Rezervujte si svoj termín ešte dnes!
        </p>
        <Image
          src={'/images/banner-model.png'}
          alt="Modelka"
          width={0}
          height={0}
          className="absolute left-[52%] top-0 z-[2] h-full w-auto"
          sizes="100vw"
        />
        <Image
          src={'/images/large-banner-elipse.png'}
          alt="Elipsa"
          width={0}
          height={0}
          className="absolute left-[43%] top-0 h-full w-auto"
          sizes="100vw"
        />
        <Button asChild variant={'white'}>
          <Link prefetch={false} href={'/rezervacia'}>
            <Image
              src={'/images/calendar-black.svg'}
              alt=""
              width={0}
              height={0}
              className="max-h-5 min-h-5 min-w-5 max-w-5 object-contain"
            />
            {t('text4069')}
          </Link>
        </Button>
      </div>
    </>
  );
}
